import { render } from "./Produce.vue?vue&type=template&id=f119964e&scoped=true"
import script from "./Produce.vue?vue&type=script&lang=js"
export * from "./Produce.vue?vue&type=script&lang=js"

import "./Produce.vue?vue&type=style&index=0&id=f119964e&scoped=true&lang=scss"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f119964e"]])

export default __exports__